import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Table, Column, Button } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class List extends React.Component {

	@observable records = null;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.records = await store.model.Fraction.find({ order: 'id asc' });
	};
	
	create = () => this.props.history.push('/admin/fractions/create');
	
	render() {
		if (!this.records) return '...';
		
		return <>
			<p>Фракции</p>
			<p><Button className="btn-primary" onClick={this.create}>Создать</Button></p>
			<Table records={this.records} rootPath="/admin">
				<Column width={60} property="id" label="id" />
				<Column property="shortName" label="Наименование" />
				<Column property="existing" label="Существует" />
			</Table>
		</>;
	}
	
}
